import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";

async function getRefFaskes(nama: string) {
  const response = await http
    .getData(`/faskes?nama=${nama}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

export default {
  getRefFaskes
};
